export default {
  photoCollection: 'photos',

  Cloudinary: {
    ApiKey: '613169486165861',
    UploadPreset: 'doha_unsigned',
  },
}



// WEBPACK FOOTER //
// ./src/config.prod.ts